module.exports = __webpack_public_path__ + "resources/img/img_appen_data1_m.097ad5cf685d0259a154eaba5f58bcd1.png";